export function extractErrorCode(
  errorResponse: Record<string, unknown> | unknown[]
) {
  if (Array.isArray(errorResponse)) {
    const firstError = errorResponse[0] as Record<string, unknown>;
    return typeof firstError['errorCode'] === 'number'
      ? firstError['errorCode']
      : -1;
  } else if (typeof errorResponse['error'] !== 'undefined') {
    const error = errorResponse['error'] as Record<string, unknown>;
    if (typeof error['errorCode'] === 'number') {
      return error['errorCode'];
    }
  } else if (typeof errorResponse['errorCode'] === 'number') {
    return errorResponse['errorCode'];
  } else if (
    Array.isArray(errorResponse['errors']) &&
    errorResponse['errors'].length > 0
  ) {
    const firstError = errorResponse['errors'][0] as Record<string, unknown>;
    if (typeof firstError['errorCode'] === 'number') {
      return firstError['errorCode'];
    }
  }
  return -1;
}
